import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "row", "hideRow", "showRow", "groupHeader", "recordCount" ]

  rowTargetDisconnected(target) {
    const value = target.dataset.groupedValue
    const recordCount = this.#countRowTargetsByValue(value)
    if (recordCount == 0) {
      this.#hideHeaderRow(value)
    } else {
      this.#updateHeaderRowCounts(value, recordCount)
    }
  }

  #hideHeaderRow(value) {
    this.groupHeaderTargets.forEach(row => (value == row.dataset.groupedValue) && row.classList.add("hidden"))
  }

  #updateHeaderRowCounts(value, recordCount) {
    this.recordCountTargets.forEach(row => (value == row.dataset.groupedValue) && (row.innerHTML = "(" + recordCount + ")"))
  }

  toggleGroup(event) {
    const clickedElement = event.target
    const tagName = clickedElement.tagName.toLowerCase()
    const excludedTags = ["a", "i", "button", "input"]

    if (excludedTags.includes(tagName)) {
      return
    }

    const row = event.target.closest("tr")

    if (row.querySelector(".hide-row").classList.contains("hidden")) {
      this.#showGroup(row)
    } else  {
      this.#hideGroup(row)
    }
  }

  hideRows(event) {
    this.#hideGroup(event.target.closest("tr"))
  }

  showRows(event) {
    this.#showGroup(event.target.closest("tr"))
  }

  toggleGroupSelected(event) {
    const value = event.target.dataset.groupedValue
    const checked = event.target.checked

    this.rowTargets.forEach(row => {
      if (value == row.dataset.groupedValue) {
        const checkbox = row.querySelector('[data-grids--bulk-select-target="selectCheckbox"]')
        if (checkbox?.checked !== checked) {
          checkbox.checked = checked
          checkbox.dispatchEvent(new Event("change", { bubbles: true }))
        }
      }
    })
  }

  #showGroup(row) {
    const value = row.dataset.groupedValue
    this.rowTargets.forEach(row => (value == row.dataset.groupedValue) && row.classList.remove("hidden"))
    row.querySelector(".hide-row").classList.remove("hidden")
    row.querySelector(".show-row").classList.add("hidden")
  }

  #hideGroup(row) {
    const value = row.dataset.groupedValue
    this.rowTargets.forEach(row => (value == row.dataset.groupedValue) && row.classList.add("hidden"))
    row.querySelector(".hide-row").classList.add("hidden")
    row.querySelector(".show-row").classList.remove("hidden")
  }

  #countRowTargetsByValue(value) {
    return this.rowTargets.filter(row => row.dataset.groupedValue == value).length
  }
}
